export default "__VITE_ASSET__d459726a__"